import { render } from "./CursorStalker.vue?vue&type=template&id=284b61b8"
import script from "./CursorStalker.vue?vue&type=script&lang=js"
export * from "./CursorStalker.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CursorStalker.vue?vue&type=style&index=0&id=284b61b8&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__